import { IContent, IState } from '../index';

export function getDefaultState(state: { [key: number]: IContent }, defaultIndexVisible: number) {
  const defaultState: IState = {};

  Object.keys(state).map((key: keyof typeof defaultState) => {
    defaultState[key] = false;
  });

  defaultState[defaultIndexVisible] = true;

  return defaultState;
}
